let messageStore = {
    message: []
};

export function set(_message) {
    messageStore.message = _message;
}

export function get() {
    return {
        message: messageStore.message
    };
}
